/**
 * Extended MediaTimeDisplay that persists the remaining/elapsed time preference to localStorage.
 */

import { MediaTimeDisplay } from 'media-chrome';

const STORAGE_KEY = 'bunny_player_time_display_remaining';

class BunnyTimeDisplay extends MediaTimeDisplay {
  #preferenceRestored = false;

  override connectedCallback() {
    super.connectedCallback();

    // Restore preference from localStorage once on first connect
    if (!this.#preferenceRestored) {
      this.#preferenceRestored = true;
      this.#restorePreference();
    }

    this.addEventListener('click', this.#handleClick);
  }

  override disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#handleClick);
  }

  #restorePreference() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'true') {
        this.setAttribute('remaining', '');
      } else if (stored === 'false') {
        this.removeAttribute('remaining');
      }
      // If null, use default behavior (no preference stored yet)
    } catch {
      // localStorage may be unavailable (private browsing, etc.)
    }
  }

  /** Save preference after Media Chrome toggles the attribute */
  #handleClick = () => {
    requestAnimationFrame(() => {
      try {
        const isRemaining = this.hasAttribute('remaining');
        localStorage.setItem(STORAGE_KEY, String(isRemaining));
      } catch {
        // localStorage may be unavailable
      }
    });
  };
}

if (!globalThis.customElements.get('bunny-time-display')) {
  globalThis.customElements.define('bunny-time-display', BunnyTimeDisplay);
}

export { BunnyTimeDisplay };
